import { useQuantzData, QuantzOperation, QuantzQueryCacheDuration } from '@hotjar/quantz';
import type { GlobalFilter } from '@hotjar/global-filters';

export function useGetAverageWindowHeight(
  selectedFiltersInUiFormat: GlobalFilter,
  siteId: number,
  enabled: boolean,
): number | null {
  const { data } = useQuantzData(
    {
      sessionFilters: selectedFiltersInUiFormat,
      siteId,
      operation: QuantzOperation.AVERAGE,
      // @ts-expect-error this is not a long-term solution, so no need to add it to
      // the defined/typed Quantz properties.
      property: 'window_height',
    },
    enabled,
    QuantzQueryCacheDuration.Mid,
  );

  return data?.data.result ?? null;
}
